import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import { Home } from '../features/home';
import { AccessLink } from '../features/accessLink';
import { Preview } from '../features/preview';
import { GameDetails } from '../features/gameDetails';
import { GameLauncher } from '../features/gameLauncher';
import { GamePlayPage } from '../features/gamePlay';
import { Routes as AppRoutes } from './routes';

export function AppRouter() {
    return (
        <BrowserRouter>
            <Routes>
                <Route index element={<Home />} />
                <Route path={AppRoutes.PLAY} element={<GamePlayPage />} />

                <Route element={<Layout />}>
                    <Route path={AppRoutes.PREVIEW} element={<Preview />} />
                    <Route path={`${AppRoutes.ACCESS}/:id`} element={<AccessLink />} />
                    <Route
                        path={`${AppRoutes.ACCESS}/:id/${AppRoutes.GAME}/:gameSystemName`}
                        element={<GameLauncher />}
                    />
                    <Route path={`${AppRoutes.GAME}/:gameId`} element={<GameDetails />} />
                </Route>

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </BrowserRouter>
    );
}
